import routineReducerFactory from "./routineReducerFactory";
import {fetchProductTopList} from "../actions/routines";

const productTopList = routineReducerFactory(fetchProductTopList, {data: []});

export default productTopList;